var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 52 52",
    strokeWidth: 0,
    fill: "currentColor",
    size: 16,
    width: 16,
    height: 16,
    style: {
      pointerEvents: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".Icon-passport_svg__st0{display:none}.Icon-passport_svg__st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st2{display:inline}.Icon-passport_svg__st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.Icon-passport_svg__st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-passport_svg__st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.Icon-passport_svg__st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-passport_svg__st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.Icon-passport_svg__st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127}.Icon-passport_svg__st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-passport_svg__st17{fill:none}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-passport_svg__stroke",
    className: "Icon-passport_svg__st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Icon-passport_svg__st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "Icon-passport_svg__st3",
    x1: 20,
    y1: 38,
    x2: 32,
    y2: 38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "Icon-passport_svg__st7",
    cx: 26,
    cy: 21.5,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "Icon-passport_svg__st7",
    d: "M27.3793,15.1874c0.5455,1.5399,0.8953,3.9158,0.8953,6.5815c0,2.643-0.3438,5.0011-0.8814,6.542"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Icon-passport_svg__st7",
    d: "M24.3987,28.255c-0.5265-1.5417-0.8621-3.8749-0.8621-6.4862c0-2.6402,0.3431-4.9961,0.8796-6.5371"
  }), /*#__PURE__*/React.createElement("line", {
    className: "Icon-passport_svg__st7",
    x1: 19,
    y1: 21.5,
    x2: 33,
    y2: 21.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M38,7v38H14V7H38 M38,5H14c-1.1,0-2,0.9-2,2v38c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V7C40,5.9,39.1,5,38,5L38,5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon-passport_svg__filled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0903,20.5h2.4758c0.0646-1.553,0.2447-3.014,0.5256-4.244C21.529,17.1261,20.3986,18.6743,20.0903,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1951,27.4396C25.4591,27.4752,25.7264,27.5,26,27.5c0.2053,0,0.4081-0.0106,0.6081-0.0308 c0.3771-1.3151,0.6077-3.0661,0.655-4.9692h-2.7153C24.595,24.3867,24.8232,26.1275,25.1951,27.4396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2425,20.5c-0.0883-1.9554-0.3734-3.7578-0.8058-4.9779C26.2919,15.5116,26.1474,15.5,26,15.5 c-0.2338,0-0.4634,0.0168-0.6904,0.0429l0.0507,0.0176c-0.4311,1.2393-0.7075,2.9961-0.7928,4.9395H27.2425z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0903,22.5c0.2998,1.7756,1.3791,3.2855,2.8759,4.1677c-0.2372-1.2411-0.3823-2.6682-0.418-4.1677H20.0903z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8204,26.7927c1.6082-0.8604,2.7752-2.4328,3.0892-4.2927h-2.647C29.2258,24.0517,29.0722,25.5234,28.8204,26.7927z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,5c-1.1,0-2,0.9-2,2v38c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V7c0-1.1-0.9-2-2-2H14z M32,39H20c-0.5522,0-1-0.4478-1-1 s0.4478-1,1-1h12c0.5522,0,1,0.4478,1,1S32.5522,39,32,39z M26,29.5c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8s8,3.5889,8,8 S30.4111,29.5,26,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6929,16.1457c0.2957,1.2525,0.4857,2.752,0.5522,4.3543h2.6646C31.5875,18.592,30.3654,16.9904,28.6929,16.1457z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.575608b15f25022662e27847d88b36b6.svg";
export { ForwardRef as ReactComponent };